import { render } from "./GestionEnvoisPostauxView.vue?vue&type=template&id=3945fad0&scoped=true"
import script from "./GestionEnvoisPostauxView.vue?vue&type=script&lang=js"
export * from "./GestionEnvoisPostauxView.vue?vue&type=script&lang=js"

import "./GestionEnvoisPostauxView.vue?vue&type=style&index=0&id=3945fad0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3945fad0"]])

export default __exports__